export enum Theme {
  Dark = 'dark-theme',
  Light = 'light-theme',
  Pinroutes = 'pinroutes-theme'
}
